import React, { useContext, useEffect, useState } from "react";
import HeadingBanner from "../Components/HeadingBanner.jsx";
import Dashboard from "../Components/Dashboard.jsx";
import { useNavigate } from "react-router-dom";
import { Logindetail } from "../context/Logindetail.js";
import * as Yup from "yup";
import { useFormik } from "formik";
import toast from "react-hot-toast";
import {
  editkyc_fun,
  getprofile_fun,
  update_fun,
} from "../api/Dashboardapi.js";
import { X } from "react-bootstrap-icons";

const Kyc = ({ settings }) => {
  const [spinner, setspinner] = useState(false);
  const [adharfile, setAdharfile] = useState([]);
  const [panfile, setpanfile] = useState([]);
  const [existingAadharDoc,setExistingAadharDoc] = useState([]);
  const [existingPanDoc,setExistingPanDocs] = useState([])


  const { detail_info, setdetail_info } = useContext(Logindetail);


  useEffect(()=>{
     if (detail_info) {
      // Handle Aadhar documents
      if (detail_info.aadhar_documents_image) {
        if (Array.isArray(detail_info.aadhar_documents_image)) {
          setExistingAadharDoc(detail_info.aadhar_documents_image);
        } else if (typeof detail_info.aadhar_documents_image === 'string') {
          try {
            const parsedDocs = JSON.parse(detail_info.aadhar_documents_image);
            setExistingAadharDoc(Array.isArray(parsedDocs) ? parsedDocs : [parsedDocs]);
          } catch {
            setExistingAadharDoc([detail_info.aadhar_documents_image]);
          }
        }
      }
    


            // Handle Pan documents
      if (detail_info.pan_documents_image) {
        if (Array.isArray(detail_info.pan_documents_image)) {
          setExistingPanDocs(detail_info.pan_documents_image);
        } else if (typeof detail_info.pan_documents_image === 'string') {
          try {
            const parsedDocs = JSON.parse(detail_info.pan_documents_image);
            setExistingPanDocs(Array.isArray(parsedDocs) ? parsedDocs : [parsedDocs]);
          } catch {
            setExistingPanDocs([detail_info.pan_documents_image]);
          }
        }
      }
    }
    


    
  },[])


  const [initValue, setinitValue] = useState({
    name_as_aadhar: `${
      detail_info?.name_as_aadhar ? detail_info?.name_as_aadhar : ""
    }`,
    aadhar_number: `${
      detail_info?.aadhar_number ? detail_info?.aadhar_number : ""
    }`,
    name_as_pan: `${detail_info?.name_as_pan ? detail_info?.name_as_pan : ""}`,
    pan_number: `${detail_info?.pan_number ? detail_info?.pan_number : ""}`,
    verified: detail_info?.verified ? detail_info?.verified : 1,
    pan_documents: `${
      detail_info?.pan_documents ? detail_info?.pan_documents : ""
    }`,
    aadhar_documents: `${
      detail_info?.aadhar_documents ? detail_info?.aadhar_documents : ""
    }`,
  });

  const updateschema = Yup.object().shape({
    name_as_aadhar: Yup.string()
           .required("Enter the Name as Aadhar Document")
            .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
            .test(
                "not-only-spaces",
                "Name cannot be only spaces",
                (value) => value && value.trim().length > 0),
      // .matches(/^[a-zA-Z ]*$/, "Invalid Aadhar name"),

      
    name_as_pan: Yup.string()
           .required("Enter the Name as Pan Document")
            .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
            .test(
                "not-only-spaces",
                "Name cannot be only spaces",
                (value) => value && value.trim().length > 0),

    aadhar_number: Yup.string()
      .required("Enter Aadhar Number")
      .min(12, "Aadhar number Minimum 12 digits")
      // .max(12, 'Aadhar number Minimum 12 digits')
      .matches(/^[0-9]+$/, "Invalid  Aadhar number"),


    pan_number: Yup.string()
      .required("Enter PAN number")
      .matches(
        /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
        "Pan number must contain 10 characters, including five uppercase letter,  four number, and last one uppercase letter"
      ),

      
    aadhar_documents: Yup.mixed().test(
      "required",
      "Aadhar document is required",
      function (value) {
        return adharfile.length > 0 || existingAadharDoc.length > 0;
      }
    ),

    pan_documents: Yup.mixed().test(
      "required",
      "PAN document is required",
      function (value) {
        return panfile.length > 0 || existingPanDoc.length > 0;
      }
    ),

  });

  const handlegetprofile = () => {
    getprofile_fun()
      .then((res) => {
        localStorage.setItem("green_login", JSON.stringify(res?.data));
        setdetail_info(res?.data);
        // setfile(res?.data?.avatar);
      })
      .catch((err) => {
      });
  };

  const Formrik = useFormik({
    initialValues: initValue,
    validationSchema: updateschema,
    onSubmit: async (value, { setErrors, setStatus, resetForm }) => {
      const formdata = new FormData();
      formdata.append("name_as_aadhar", value.name_as_aadhar);
      formdata.append("aadhar_number", value.aadhar_number);
      formdata.append("name_as_pan", value.name_as_pan);
      formdata.append("pan_number", value.pan_number);
      adharfile?.map((data, i) => {
        formdata.append(`aadhar_documents[${i}]`, data);
      });
      panfile?.map((data, i) => {
        formdata.append(`pan_documents[${i}]`, data);
      });
      setspinner(true);
      update_fun(formdata)
        .then((res) => {
          toast.success("Kyc updated successfully");
          handlegetprofile();
          setspinner(false);
        })
        .catch((err) => {
          if (err?.response?.data?.status === 400) {
            toast.error(err?.response?.data?.message);
          }
          setspinner(false);
        });
    },
  });

  const handleSaveClick = async () => {
    const errors = await Formrik.validateForm();
    if (Object.keys(errors).length > 0) {
      const firstError = Object.values(errors)[0];
      toast.error(firstError);
      
      Formrik.setTouched({
        name_as_aadhar: true,
        aadhar_number: true,
        name_as_pan: true,
        pan_number: true,
        aadhar_documents: true,
        pan_documents: true
      });
    } else {
      Formrik.handleSubmit();
    }
  };

  // const handleaadhar = (e) => {
  //     setaadhardocs1(e.target.files[0])
  //     setaadhardocs2(e.target.files[1])
  // }

  // const handlepan = (e) => {
  //     setpandocs1(e.target.files[0])
  //     setpandocs2(e.target.files[1])
  // }

  // const handleaadhar = (e) => {

  //     const data = Object.values(e.target.files)

  //     for (var i = 0; i < data?.length; i++) {

  //         if (data[i]?.type === 'image/jpg' || data[i]?.type === 'image/jpeg' || data[i]?.type === 'image/png') {

  //             if (data[i]?.size <= 2 * 1024 * 1024) {
  //                 setAdharfile([...adharfile, data[i]]);
  //             }
  //             else {
  //                 toast.error('File Size Max 2MB')
  //             }
  //         }
  //         else {
  //             toast.error('Check image format')
  //         }
  //     }

  // }

  const removeExistingAadhar = (file)=>{
    setExistingAadharDoc((f)=> f?.filter((fil)=> fil != file))
  }

    const removeExistingPan = (file)=>{
    setExistingPanDocs((f)=> f?.filter((fil)=> fil != file))
  }

  const handleaadhar = (e) => {
    const data = Object.values(e.target.files);

    for (let i = 0; i < data.length; i++) {
      const file = data[i];

      if (
        file?.type === "image/jpg" ||
        file?.type === "image/jpeg" ||
        file?.type === "image/png" ||
        file?.type === "application/pdf" 
      ) {
        setAdharfile((prev) => {
          const newFiles = [...prev, file];
          Formrik.setFieldValue("aadhar_documents", newFiles);
          return newFiles;
        });
      } else {
        toast.error("Only JPG, PNG, or PDF files are allowed");
      }
    }
  };

  const cancelimage = (value) => {
    setAdharfile((p) => {
      const newFiles = p?.filter((r) => r != value);
      Formrik.setFieldValue("aadhar_documents", newFiles.length > 0 ? newFiles : "");
      return newFiles;
    });
  };

  
// const FilePreview = ({ file, onRemove, type = "new" }) => {
//   const isImage = file.type
//     ? file.type.startsWith("image/")
//     : typeof file === "string" && !file.toLowerCase().endsWith(".pdf");

//   const isPDF = file.type
//     ? file.type === "application/pdf"
//     : typeof file === "string" && file.toLowerCase().endsWith(".pdf");

//   const fileUrl = file.type ? URL.createObjectURL(file) : file;
//   const fileName =
//     file.name || (typeof file === "string" ? file.split("/").pop() : "Document");

//   return (
//     <div
//       className="position-relative m-2 p-2 border rounded bg-light"
//       style={{ width: "140px" }}
//     >
//       <div className="text-center">
//         {isImage ? (
//           <>
//             <img
//               src={fileUrl}
//               className="img-fluid"
//               style={{ maxWidth: "80px", maxHeight: "80px", objectFit: "cover" }}
//               alt={type === "existing" ? "Existing document" : "New document"}
//               onError={(e) => {
//                 e.target.src = "/assets/icons/document.png";
//               }}
//             />
//           </>
//         ) : isPDF ? (
//           <>
//             <iframe
//               src={fileUrl}
//               title="PDF Preview"
//               style={{
//                 width: "100px",
//                 height: "100px",
//                 border: "1px solid #ccc",
//               }}
//             />
//           </>
//         ) : (
//           <img
//             src="/assets/icons/document.png"
//             alt="File"
//             className="img-fluid"
//             style={{ width: "80px", height: "80px" }}
//           />
//         )}
//         <div className="small text-truncate mt-1" style={{ width: "100px" }}>
//           {fileName}
//         </div>
//         <div
//           className={`badge ${type === "existing" ? "bg-info" : "bg-success"}`}
//           style={{ fontSize: "8px" }}
//         >
//           {type.toUpperCase()}
//         </div>
//       </div>

//       <button
//         type="button"
//         className="position-absolute bg-danger text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
//         style={{
//           width: "20px",
//           height: "20px",
//           top: "-8px",
//           right: "-8px",
//           cursor: "pointer",
//           fontSize: "12px",
//         }}
//         onClick={() => onRemove(file)}
//         title={`Remove ${type} document`}
//       >
//         <X size={12} />
//       </button>
//     </div>
//   );
// };



  // const handlepan = (e) => {

  //     const data = Object.values(e.target.files)

  //     for (var i = 0; i < data?.length; i++) {

  //         if (data[i]?.type === 'image/jpg' || data[i]?.type === 'image/jpeg' || data[i]?.type === 'image/png') {

  //             if (data[i]?.size > 2 * 1024 * 1024 ||  e.target.files[0]?.size <= 0) {
  //                 toast.error('File Size Max 2MB')
  //             }
  //             else {

  //                 setpanfile([...panfile, data[i]]);
  //             }
  //         }
  //         else {
  //             toast.error('Check image format')
  //         }
  //     }

  // }



const FilePreview = ({ file, onRemove, type = "new" }) => {
  const isImage = file.type
    ? file.type.startsWith("image/")
    : typeof file === "string" && !file.toLowerCase().endsWith(".pdf");

  const isPDF = file.type
    ? file.type === "application/pdf"
    : typeof file === "string" && file.toLowerCase().endsWith(".pdf");

  const fileUrl = file.type ? URL.createObjectURL(file) : file;
  const fileName =
    file.name || (typeof file === "string" ? file.split("/").pop() : "Document");

  const handleOpenInNewTab = () => {
    window.open(fileUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="position-relative m-2 p-2 border rounded bg-light"
      style={{ width: "120px", cursor: "pointer" }}
      onClick={handleOpenInNewTab}
      title="Click to open in new tab"
    >
      <div className="text-center">
        {isImage ? (
          <img
            src={fileUrl}
            className="img-fluid"
            style={{ maxWidth: "80px", maxHeight: "80px", objectFit: "cover" }}
            // alt={type === "existing" ? "Existing document" : "New document"}
            onError={(e) => {
              e.target.src = "/assets/iocns/ifsc code.png";
            }}
          />
        ) : isPDF ? (
          <img
            src="/assets/iocns/pdf.png"
            alt="PDF document"
            className="img-fluid"
            style={{ width: "50px", height: "50px" }}
          />
        ) : (
          <img
            src="/assets/icons/ifsc code  .png"
            alt="Unknown file"
            className="img-fluid"
            style={{ width: "50px", height: "50px" }}
          />
        )}
        <div className="small text-truncate mt-1" style={{ width: "100px" }}>
          {fileName}
        </div>
        {/* <div
          className={`badge ${type === "existing" ? "bg-info" : "bg-success"}`}
          style={{ fontSize: "8px" }}
        >
          {type.toUpperCase()}
        </div> */}
      </div>

      <button
        type="button"
        className="position-absolute bg-danger text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
        style={{
          width: "20px",
          height: "20px",
          top: "-8px",
          right: "-8px",
          cursor: "pointer",
          fontSize: "12px",
        }}
        onClick={(e) => {
          e.stopPropagation();
          onRemove(file);
        }}
        title={`Remove ${type} document`}
      >
        <X size={12} />
      </button>
    </div>
  );
};



  const handlepan = (e) => {
    const data = Object.values(e.target.files);

    for (let i = 0; i < data.length; i++) {
      const file = data[i];

      if (
        file?.type === "image/jpg" ||
        file?.type === "image/jpeg" ||
        file?.type === "image/png" ||
        file?.type === "application/pdf" // ✅ Allow PDF
      ) {
        setpanfile((prev) => {
          const newFiles = [...prev, file];
          Formrik.setFieldValue("pan_documents", newFiles);
          return newFiles;
        });
      } else {
        toast.error("Only JPG, PNG, or PDF files are allowed");
      }
    }
  };

  const cancelimage2 = (value) => {
    setpanfile((p) => {
      const newFiles = p?.filter((e) => e != value);
      Formrik.setFieldValue("pan_documents", newFiles.length > 0 ? newFiles : "");
      return newFiles;
    });
  };
  return (
    <>
      <HeadingBanner title={"KYC"} />
      <section>
        <div className="kyc-layout">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-4">
                <Dashboard setting_data={settings} />
              </div>
              <div className="col-xl-9 col-lg-8">
                <div className="kyc-content">
                  <div className="bd-heads pb-3">
                    <h4>KYC</h4>
                  </div>
                  <div className="bd-form border">
                    <form onSubmit={Formrik.handleSubmit}>
                      <div className="row">
                        <div className="form-group col-md-6 col-sm-6 col-6 login-text">
                          <label>
                            Name as Aadhar Card
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputaddress"
                            placeholder="Name as Aadhar Card"
                            {...Formrik.getFieldProps("name_as_aadhar")}
                          />
                        </div>
                        <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                          <label>
                            Name as Pan Card
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputaddress2"
                            placeholder="Name as Pan Card"
                            {...Formrik.getFieldProps("name_as_pan")}
                          />
                        </div>

                        <div className="form-group col-md-6  col-sm-6 col-6  login-text">
                          <label>
                            Aadhar Number
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="number"
                            maxLength={12}
                            className="form-control"
                            id="inputaddress2"
                            placeholder="Aadhar Number"
                            {...Formrik.getFieldProps("aadhar_number")}
                          />
                        </div>

                        <div className="form-group col-md-6  col-sm-6 col-6 login-text">
                          <label>
                            Pan Number
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="inputaddress2"
                            placeholder="Pan Number"
                            {...Formrik.getFieldProps("pan_number")}
                          />
                        </div>
                        
                        <div className="form-group mb-3 col-md-6 col-12 login-text">
                          <label>
                            Upload Aadhar Documents{" "}
                            <span className="text-danger">*</span>
                            <span className="text-danger doc-format">
                              *(PNG,JPG,JPEG,PDF)
                            </span>
                          </label>
                          <div className="upload-docs">
                            <button
                              className="btn"
                              type="button"
                              onClick={() => {
                                document.getElementById("aadharfile").click();
                              }}
                            >
                              {" "}
                              <span>
                                <img src="\assets\iocns\upload.png" alt="" />
                              </span>{" "}
                              Image Upload
                            </button>
                          </div>
                          <input
                            className="form-control d-none"
                            id="aadharfile"
                            type="file"
                            accept="image/jpg, image/jpeg, image/png, application/pdf"
                            multiple="multiple"
                            onChange={handleaadhar}
                          />

                                 {/* Existing Aadhar Documents from API */}
                       {existingAadharDoc.length > 0 && (
                            <div className="mt-3">
                              <h6 className="mb-2">Existing Aadhar Documents:</h6>
                              <div className="d-flex flex-wrap">
                                {existingAadharDoc.map((doc, index) => (
                                  <FilePreview
                                    key={`existing-aadhar-${index}`}
                                    file={doc}
                                    onRemove={removeExistingAadhar}
                                    type="existing"
                                  />
                                ))}
                              </div>
                            </div>
                          )}


                     


                          {adharfile.length>0 && <h6 className="mt-2 mb-2">Uploaded Aadhar Documents:</h6>}

                          <div className="selected-file d-flex flex-wrap login-text">
                          
                            {adharfile?.map((data, i) => {
                               const isImage = data.type.startsWith("image/");
                               const isPDF = data.type === "application/pdf";
                              return (
                            
                           
                                <div className="position-relative" key={i}>
                              



                                     {isImage && (
                                    <img
                                      src={URL.createObjectURL(data)}
                                      className="img-fluid docimg"
                                      alt=""
                                    />
                                  )}
                                  {isPDF && (
                                    <div className="pdf-preview">
                                      <a
                                        href={URL.createObjectURL(data)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src="/assets/iocns/pdf.png"
                                          alt="PDF Icon"
                                           className="img-fluid"
                                        />
                                         <div className="small text-truncate mt-1" style={{ width: "100px" }}>
         {data.name}
        </div>
                                        <p></p>
                                      </a>
                                    </div>
                                  )}



                                  {/* <img
                                    src={URL.createObjectURL(data)}
                                    className="img-fluid docimg"
                                    alt=""
                                  /> */}
                                  <div
                                    className="diselect position-absolute"
                                    onClick={() => {
                                      cancelimage(data);
                                    }}
                                  >
                                    <X />
                                  </div>
                                </div>
                            
                              );
                            })}
                          </div>
                        </div>

                        


                        

                        
                        <div className="form-group mb-3 col-md-6 col-12 login-text">
                          <label>
                            Upload Pan Documents <span className="text-danger">*</span>
                            <span className="text-danger doc-format">
                              *(PNG,JPG,JPEG,PDF)
                            </span>
                          </label>
                          <div className="upload-docs">
                            <button
                              className="btn"
                              type="button"
                              onClick={() => {
                                document.getElementById("panfile").click();
                              }}
                            >
                              {" "}
                              <span>
                                <img src="\assets\iocns\upload.png" alt="" />
                              </span>{" "}
                              Image Upload
                            </button>
                          </div>
                          <input
                            className="form-control d-none"
                            id="panfile"
                            accept="image/jpg, image/jpeg, image/png, application/pdf"
                            multiple="multiple"
                            type="file"
                            onChange={handlepan}
                          />


           {existingPanDoc.length > 0 && (
                            <div className="mt-3">
                              <h6 className="mb-2">Existing Pan Documents:</h6>
                              <div className="d-flex flex-wrap">
                                {existingPanDoc.map((doc, index) => (
                                  <FilePreview
                                    key={`existing-aadhar-${index}`}
                                    file={doc}
                                    onRemove={removeExistingPan}
                                    type="existing"
                                  />
                                ))}
                              </div>
                            </div>
                          )}





  {panfile.length>0 && <h6 className="mt-2 mb-2">Uploaded Aadhar Documents:</h6>}
                          <div className="selected-file d-flex flex-wrap login-text">
                            {panfile?.map((data, i) => {
                              const isImage = data.type.startsWith("image/");
                              const isPDF = data.type === "application/pdf";
                              return (
                                <div className="position-relative" key={i}>
                                  {/* <img src={URL.createObjectURL(data)} className="img-fluid docimg" alt="" /> */}

                                  {isImage && (
                                    <img
                                      src={URL.createObjectURL(data)}
                                      className="img-fluid docimg"
                                      alt=""
                                    />
                                  )}
                                  {isPDF && (
                                    <div className="pdf-preview">
                                      <a
                                        href={URL.createObjectURL(data)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src="/assets/iocns/pdf.png"
                                          alt="PDF Icon"
                                          className="img-fluid"
                                        />
                                                                                <div className="small text-truncate mt-1" style={{ width: "100px" }}>
         {data.name}
        </div>
                                      </a>
                                    </div>
                                  )}
                                  <div
                                    className="diselect position-absolute"
                                    onClick={() => {
                                      cancelimage2(data);
                                    }}
                                  >
                                    <X />
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                      <div className="update-profile  mx-3">
                        <button
                          disabled={spinner}
                          className="text-white"
                          type="button"
                          onClick={handleSaveClick}
                        >
                          {spinner ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                            ></span>
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Kyc;
// import React, { useContext, useEffect, useState } from "react";
// import HeadingBanner from "../Components/HeadingBanner.jsx";
// import Dashboard from "../Components/Dashboard.jsx";
// import { useNavigate } from "react-router-dom";
// import { Logindetail } from "../context/Logindetail.js";
// import * as Yup from "yup";
// import { useFormik } from "formik";
// import toast from "react-hot-toast";
// import {
//   editkyc_fun,
//   getprofile_fun,
//   update_fun,
// } from "../api/Dashboardapi.js";
// import { X } from "react-bootstrap-icons";

// const Kyc = ({ settings }) => {
//   const [spinner, setspinner] = useState(false);
//   const [adharfile, setAdharfile] = useState([]);
//   const [panfile, setpanfile] = useState([]);
//   const [existingAadharDocs, setExistingAadharDocs] = useState([]);
//   const [existingPanDocs, setExistingPanDocs] = useState([]);

//   const { detail_info, setdetail_info } = useContext(Logindetail);

//   // Load existing documents when component mounts or detail_info changes
//   useEffect(() => {
//     if (detail_info) {
//       // Handle Aadhar documents
//       if (detail_info.aadhar_documents) {
//         if (Array.isArray(detail_info.aadhar_documents)) {
//           setExistingAadharDocs(detail_info.aadhar_documents);
//         } else if (typeof detail_info.aadhar_documents === 'string') {
//           // If it's a string, try to parse it as JSON or use as single document
//           try {
//             const parsedDocs = JSON.parse(detail_info.aadhar_documents);
//             setExistingAadharDocs(Array.isArray(parsedDocs) ? parsedDocs : [parsedDocs]);
//           } catch {
//             setExistingAadharDocs([detail_info.aadhar_documents]);
//           }
//         }
//       }

//       // Handle Pan documents
//       if (detail_info.pan_documents) {
//         if (Array.isArray(detail_info.pan_documents)) {
//           setExistingPanDocs(detail_info.pan_documents);
//         } else if (typeof detail_info.pan_documents === 'string') {
//           try {
//             const parsedDocs = JSON.parse(detail_info.pan_documents);
//             setExistingPanDocs(Array.isArray(parsedDocs) ? parsedDocs : [parsedDocs]);
//           } catch {
//             setExistingPanDocs([detail_info.pan_documents]);
//           }
//         }
//       }
//     }
//   }, [detail_info]);

//   const [initValue, setinitValue] = useState({
//     name_as_aadhar: `${
//       detail_info?.name_as_aadhar ? detail_info?.name_as_aadhar : ""
//     }`,
//     aadhar_number: `${
//       detail_info?.aadhar_number ? detail_info?.aadhar_number : ""
//     }`,
//     name_as_pan: `${detail_info?.name_as_pan ? detail_info?.name_as_pan : ""}`,
//     pan_number: `${detail_info?.pan_number ? detail_info?.pan_number : ""}`,
//     verified: detail_info?.verified ? detail_info?.verified : 1,
//     pan_documents: `${
//       detail_info?.pan_documents ? detail_info?.pan_documents : ""
//     }`,
//     aadhar_documents: `${
//       detail_info?.aadhar_documents ? detail_info?.aadhar_documents : ""
//     }`,
//   });

//   const updateschema = Yup.object().shape({
//     name_as_aadhar: Yup.string()
//       .required("Name as Aadhar")
//       .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
//       .test(
//         "not-only-spaces",
//         "Name cannot be only spaces",
//         (value) => value && value.trim().length > 0
//       ),

//     aadhar_number: Yup.string()
//       .required("Enter Aadhar Number")
//       .min(12, "Aadhar number Minimum 12 digits")
//       .matches(/^[0-9]+$/, "Invalid Aadhar number"),

//     name_as_pan: Yup.string()
//       .required("Name as Pan card")
//       .matches(/^[a-zA-Z ]+$/, "Only letters and spaces allowed")
//       .test(
//         "not-only-spaces",
//         "Name cannot be only spaces",
//         (value) => value && value.trim().length > 0
//       ),

//     pan_number: Yup.string()
//       .required("Enter PAN number")
//       .matches(
//         /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
//         "Pan number must contain 10 characters, including five uppercase letter, four number, and last one uppercase letter"
//       ),

//     pan_documents: Yup.mixed(),
//     aadhar_documents: Yup.mixed(),
//   });

//   const handlegetprofile = () => {
//     getprofile_fun()
//       .then((res) => {
//         localStorage.setItem("green_login", JSON.stringify(res?.data));
//         setdetail_info(res?.data);
//       })
//       .catch((err) => {
//         console.log(err);
//       });
//   };

//   const Formrik = useFormik({
//     initialValues: initValue,
//     enableReinitialize: true,
//     validationSchema: updateschema,
//     onSubmit: async (value, { setErrors, setStatus, resetForm }) => {
//       const formdata = new FormData();
//       formdata.append("name_as_aadhar", value.name_as_aadhar);
//       formdata.append("aadhar_number", value.aadhar_number);
//       formdata.append("name_as_pan", value.name_as_pan);
//       formdata.append("pan_number", value.pan_number);
      
//       // Append new Aadhar files
//       adharfile?.forEach((data, i) => {
//         formdata.append(`aadhar_documents[${i}]`, data);
//       });
      
//       // Append new Pan files
//       panfile?.forEach((data, i) => {
//         formdata.append(`pan_documents[${i}]`, data);
//       });
      
//       setspinner(true);
//       update_fun(formdata)
//         .then((res) => {
//           toast.success("KYC updated successfully");
//           handlegetprofile();
//           setspinner(false);
//         })
//         .catch((err) => {
//           console.log(err);
//           if (err?.response?.data?.status === 400) {
//             toast.error(err?.response?.data?.message);
//           }
//           setspinner(false);
//         });
//     },
//   });

//   // Handle Aadhar documents upload
//   const handleaadhar = (e) => {
//     const files = Array.from(e.target.files);
//     const updatedFiles = [...adharfile];

//     for (let file of files) {
//       if (
//         file?.type === "image/jpg" ||
//         file?.type === "image/jpeg" ||
//         file?.type === "image/png" ||
//         file?.type === "application/pdf"
//       ) {
//         if (file.size <= 2 * 1024 * 1024) {
//           updatedFiles.push(file);
//         } else {
//           toast.error(`File ${file.name} size exceeds 2MB`);
//         }
//       } else {
//         toast.error("Only JPG, PNG, or PDF files are allowed");
//       }
//     }

//     setAdharfile(updatedFiles);
//     Formrik.setFieldValue("aadhar_documents", updatedFiles);
//     e.target.value = "";
//   };

//   // Handle Pan documents upload
//   const handlepan = (e) => {
//     const files = Array.from(e.target.files);
//     const updatedFiles = [...panfile];

//     for (let file of files) {
//       if (
//         file?.type === "image/jpg" ||
//         file?.type === "image/jpeg" ||
//         file?.type === "image/png" ||
//         file?.type === "application/pdf"
//       ) {
//         if (file.size <= 2 * 1024 * 1024) {
//           updatedFiles.push(file);
//         } else {
//           toast.error(`File ${file.name} size exceeds 2MB`);
//         }
//       } else {
//         toast.error("Only JPG, PNG, or PDF files are allowed for Pan documents");
//       }
//     }

//     setpanfile(updatedFiles);
//     Formrik.setFieldValue("pan_documents", updatedFiles);
//     e.target.value = "";
//   };

//   // Remove Aadhar file
//   const cancelimage = (fileToRemove) => {
//     const updatedFiles = adharfile.filter(file => file !== fileToRemove);
//     setAdharfile(updatedFiles);
//     Formrik.setFieldValue("aadhar_documents", updatedFiles);
//   };

//   // Remove Pan file
//   const cancelimage2 = (fileToRemove) => {
//     const updatedFiles = panfile.filter(file => file !== fileToRemove);
//     setpanfile(updatedFiles);
//     Formrik.setFieldValue("pan_documents", updatedFiles);
//   };

//   // File Preview Component for new files
//   const FilePreview = ({ file, onRemove, type = "new" }) => {
//     const isImage = file.type ? file.type.startsWith("image/") : 
//                     (typeof file === 'string' && !file.toLowerCase().endsWith('.pdf'));
//     const isPDF = file.type ? file.type === "application/pdf" : 
//                   (typeof file === 'string' && file.toLowerCase().endsWith('.pdf'));

//     const fileUrl = file.type ? URL.createObjectURL(file) : file;
//     const fileName = file.name || (typeof file === 'string' ? file.split('/').pop() : 'Document');

//     return (
//       <div className="position-relative m-2 p-2 border rounded bg-light" style={{ width: "120px" }}>
//         {isImage ? (
//           <div className="text-center">
//             <img
//               src={fileUrl}
//               className="img-fluid"
//               style={{ maxWidth: "80px", maxHeight: "80px", objectFit: "cover" }}
//               alt={type === "existing" ? "Existing document" : "New document"}
//               onError={(e) => {
//                 e.target.src = "/assets/iocns/document.png";
//               }}
//             />
//             <div className="small text-truncate mt-1" style={{ width: "100px" }}>
//               {fileName}
//             </div>
//             {type === "existing" && (
//               <div className="badge bg-info" style={{ fontSize: "8px" }}>EXISTING</div>
//             )}
//             {type === "new" && (
//               <div className="badge bg-success" style={{ fontSize: "8px" }}>NEW</div>
//             )}
//           </div>
//         ) : (
//           <div className="text-center">
//             <a
//               href={fileUrl}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-decoration-none text-dark"
//             >
//               <div>
//                 <img
//                   src="/assets/iocns/pdf.png"
//                   alt="PDF document"
//                   className="img-fluid"
//                   style={{ width: "50px", height: "50px" }}
//                 />
//               </div>
//               <div className="small text-truncate mt-1" style={{ width: "100px" }}>
//                 {fileName}
//               </div>
//               {type === "existing" && (
//                 <div className="badge bg-info" style={{ fontSize: "8px" }}>EXISTING</div>
//               )}
//               {type === "new" && (
//                 <div className="badge bg-success" style={{ fontSize: "8px" }}>NEW</div>
//               )}
//             </a>
//           </div>
//         )}
//         <button
//           type="button"
//           className="position-absolute bg-danger text-white border-0 rounded-circle d-flex align-items-center justify-content-center"
//           style={{ 
//             width: "20px", 
//             height: "20px", 
//             top: "-8px", 
//             right: "-8px", 
//             cursor: "pointer",
//             fontSize: "12px"
//           }}
//           onClick={() => onRemove(file)}
//           title={`Remove ${type} document`}
//         >
//           <X />
//         </button>
//       </div>
//     );
//   };

//   return (
//     <>
//       <HeadingBanner title={"KYC"} />
//       <section>
//         <div className="kyc-layout">
//           <div className="container">
//             <div className="row">
//               <div className="col-xl-3 col-lg-4">
//                 <Dashboard setting_data={settings} />
//               </div>
//               <div className="col-xl-9 col-lg-8">
//                 <div className="kyc-content">
//                   <div className="bd-heads pb-3">
//                     <h4>KYC</h4>
//                   </div>
//                   <div className="bd-form border">
//                     <form onSubmit={Formrik.handleSubmit}>
//                       <div className="row">
//                         {/* Other form fields... */}
//                               <div className="form-group col-md-6 col-sm-6 col-6 login-text">
//                           <label>Name as Aadhar Card</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             id="inputaddress"
//                             placeholder="Name as Aadhar Card"
//                             {...Formrik.getFieldProps("name_as_aadhar")}
//                           />
//                           {Formrik.touched.name_as_aadhar &&
//                           Formrik.errors.name_as_aadhar ? (
//                             <p className="text-danger">
//                               {Formrik.errors.name_as_aadhar}
//                             </p>
//                           ) : null}
//                         </div>
//                         <div className="form-group col-md-6  col-sm-6 col-6  login-text">
//                           <label>Name as Pan Card</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             id="inputaddress2"
//                             placeholder="Name as Pan Card"
//                             {...Formrik.getFieldProps("name_as_pan")}
//                           />
//                           {Formrik.touched.name_as_pan &&
//                           Formrik.errors.name_as_pan ? (
//                             <p className="text-danger m-0">
//                               {Formrik.errors.name_as_pan}
//                             </p>
//                           ) : null}
//                         </div>

//                         <div className="form-group col-md-6  col-sm-6 col-6  login-text">
//                           <label>Aadhar Number</label>
//                           <input
//                             type="number"
//                             maxLength={12}
//                             className="form-control"
//                             id="inputaddress2"
//                             placeholder="Aadhar Number"
//                             {...Formrik.getFieldProps("aadhar_number")}
//                           />
//                           {Formrik.touched.aadhar_number &&
//                           Formrik.errors.aadhar_number ? (
//                             <p className="text-danger m-0">
//                               {Formrik.errors.aadhar_number}
//                             </p>
//                           ) : null}
//                         </div>

//                         <div className="form-group col-md-6  col-sm-6 col-6 login-text">
//                           <label>Pan Number</label>
//                           <input
//                             type="text"
//                             className="form-control"
//                             id="inputaddress2"
//                             placeholder="Pan Number"
//                             {...Formrik.getFieldProps("pan_number")}
//                           />
//                           {Formrik.touched.pan_number &&
//                           Formrik.errors.pan_number ? (
//                             <p className="text-danger m-0">
//                               {Formrik.errors.pan_number}
//                             </p>
//                           ) : null}
//                         </div>
//                         {/* Aadhar Documents Upload */}
//                         <div className="form-group mb-3 col-md-6 col-12 login-text">
//                           <label>
//                             Upload Aadhar Documents{" "}
//                             <span className="text-danger doc-format">
//                               *(PNG,JPG,JPEG,PDF) Max 2MB
//                             </span>
//                           </label>
//                           <div className="upload-docs">
//                             <button
//                               className="btn"
//                               type="button"
//                               onClick={() => {
//                                 document.getElementById("aadharfile").click();
//                               }}
//                             >
//                               <span>
//                                 <img src="\assets\iocns\upload.png" alt="" />
//                               </span>
//                               Browse
//                             </button>
//                           </div>
//                           <input
//                             className="form-control d-none"
//                             id="aadharfile"
//                             type="file"
//                             accept=".jpg,.jpeg,.png,.pdf"
//                             multiple
//                             onChange={handleaadhar}
//                           />
                          
//                           {Formrik.touched.aadhar_documents &&
//                           Formrik.errors.aadhar_documents ? (
//                             <p className="text-danger m-0">
//                               {Formrik.errors.aadhar_documents}
//                             </p>
//                           ) : null}

//                           {/* Existing Aadhar Documents from API */}
//                           {existingAadharDocs.length > 0 && (
//                             <div className="mt-3">
//                               <h6 className="mb-2">Existing Aadhar Documents:</h6>
//                               <div className="d-flex flex-wrap">
//                                 {existingAadharDocs.map((doc, index) => (
//                                   <FilePreview
//                                     key={`existing-aadhar-${index}`}
//                                     file={doc}
//                                     onRemove={cancelimage}
//                                     type="existing"
//                                   />
//                                 ))}
//                               </div>
//                             </div>
//                           )}

//                           {/* New Aadhar Documents Preview */}
//                           <div className="mt-3">
//                             <h6 className="mb-2">
//                               {existingAadharDocs.length > 0 ? "New Aadhar Documents:" : "Aadhar Documents Preview:"}
//                             </h6>
//                             <div className="d-flex flex-wrap">
//                               {adharfile.length > 0 ? (
//                                 adharfile.map((file, index) => (
//                                   <FilePreview
//                                     key={`new-aadhar-${index}`}
//                                     file={file}
//                                     onRemove={cancelimage}
//                                     type="new"
//                                   />
//                                 ))
//                               ) : (
//                                 <div className="text-muted small p-2">
//                                   {existingAadharDocs.length > 0 
//                                     ? "No new documents selected" 
//                                     : "No files selected"
//                                   }
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>

//                         {/* Pan Documents Upload */}
//                         <div className="form-group mb-3 col-md-6 col-12 login-text">
//                           <label>
//                             Upload Pan Documents{" "}
//                             <span className="text-danger doc-format">
//                               *(PNG,JPG,JPEG,PDF) Max 2MB
//                             </span>
//                           </label>
//                           <div className="upload-docs">
//                             <button
//                               className="btn"
//                               type="button"
//                               onClick={() => {
//                                 document.getElementById("panfile").click();
//                               }}
//                             >
//                               <span>
//                                 <img src="\assets\iocns\upload.png" alt="" />
//                               </span>
//                               Browse
//                             </button>
//                           </div>
//                           <input
//                             className="form-control d-none"
//                             id="panfile"
//                             accept=".jpg,.jpeg,.png,.pdf"
//                             multiple
//                             type="file"
//                             onChange={handlepan}
//                           />
//                           {Formrik.touched.pan_documents &&
//                           Formrik.errors.pan_documents ? (
//                             <p className="text-danger m-0">
//                               {Formrik.errors.pan_documents}
//                             </p>
//                           ) : null}

//                           {/* Existing Pan Documents from API */}
//                           {existingPanDocs.length > 0 && (
//                             <div className="mt-3">
//                               <h6 className="mb-2">Existing Pan Documents:</h6>
//                               <div className="d-flex flex-wrap">
//                                 {existingPanDocs.map((doc, index) => (
//                                   <FilePreview
//                                     key={`existing-pan-${index}`}
//                                     file={doc}
//                                     onRemove={cancelimage2}
//                                     type="existing"
//                                   />
//                                 ))}
//                               </div>
//                             </div>
//                           )}

//                           {/* New Pan Documents Preview */}
//                           <div className="mt-3">
//                             <h6 className="mb-2">
//                               {existingPanDocs.length > 0 ? "New Pan Documents:" : "Pan Documents Preview:"}
//                             </h6>
//                             <div className="d-flex flex-wrap">
//                               {panfile.length > 0 ? (
//                                 panfile.map((file, index) => (
//                                   <FilePreview
//                                     key={`new-pan-${index}`}
//                                     file={file}
//                                     onRemove={cancelimage2}
//                                     type="new"
//                                   />
//                                 ))
//                               ) : (
//                                 <div className="text-muted small p-2">
//                                   {existingPanDocs.length > 0 
//                                     ? "No new documents selected" 
//                                     : "No files selected"
//                                   }
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>

//                         <div className="update-profile mx-3">
//                           <button
//                             disabled={spinner}
//                             className="text-white"
//                             type="submit"
//                           >
//                             {spinner ? (
//                               <span
//                                 className="spinner-border spinner-border-sm"
//                                 role="status"
//                               ></span>
//                             ) : (
//                               "Save"
//                             )}
//                           </button>
//                         </div>
//                       </div>
//                     </form>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Kyc;